import produce from 'immer'
import { actionTypes } from '../actions/cacheActions'
import { actionTypes as orderActions } from '../actions/orderActions'

const initialState = {
    foodChoice: [],
}

const CacheReducer = (state = initialState, action) =>
    produce(state, draft => {
        switch (action.type) {
            case actionTypes.SET_FOOD_CHOICE_SUCCESS: {
                draft.foodChoice = action.payload
                break
            }
            case orderActions.SET_VIEW_FOOD_DETAILS: {
                draft.foodChoice = []
                break
            }
            default:
                return state
        }
    })

export default CacheReducer
